import { AdminLogin } from '@/app/components/auth/AdminLogin'

const page = () => {
  return <AdminLogin />
}

export default page
